import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";

import ProductRecoveryChoice from "components/funnel/steps/funnelStepShipping/productRecoveryChoice/ProductRecoveryChoice";
import ProductDeliveryChoice from "components/funnel/steps/funnelStepShipping/productDeliveryChoice/ProductDeliveryChoice";
import useCart from "hooks/useCart";
import { pushRemovedFromCart } from "lib/gtm";
import { FunnelCardContainer } from "ui/funnelCardContainer/FunnelCardContainer";
import ProductCartListItem from "../../funnelStepCart/productItem/ProductListItemFunnel";
import router from "next/router";

export default function FunnelShippingOptions() {
  const classes = useStyle();
  const [cart, dispatch] = useCart();

  const deleteProduct = (product) => {
    pushRemovedFromCart(product, "basket_page");
    dispatch({ type: "remove", product });
  };

  // Redirect to empty basket when deleting all products
  React.useEffect(() => {
    if (cart.selection.length === 0) {
      router.push("/reconditionne/panier");
    }
  }, [cart]);

  return (
    <>
      <Typography color="secondary" variant="h2" className={classes.header}>
        Choisissez les détails de votre livraison
      </Typography>
      {cart.selection.map(({ product }) => (
        <Box key={product.id} mb={4}>
          <FunnelCardContainer addBorder>
            <ProductCartListItem product={product} onDelete={deleteProduct} />
            <ProductDeliveryChoice product={product} />
          </FunnelCardContainer>
        </Box>
      ))}
      {cart.shipping.recoveryEnabled && <ProductRecoveryChoice />}
    </>
  );
}

const useStyle = makeStyles((theme) => ({
  link: {
    textDecoration: "underline",
    color: theme.palette.text.primary,
  },

  warning: {
    position: "absolute",
    color: theme.palette.text.primary,
    bottom: -2,
    left: 10,
    top: "unset",
    [theme.breakpoints.down("xs")]: {
      bottom: "unset",
      top: -30,
    },
  },

  header: {
    gridColumn: "1/3",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      gridColumn: "1",
    },
  },
}));
